import { styled } from '@payright/web-components';
import { PropsWithChildren } from 'react';

interface StepBodyProps extends PropsWithChildren {}

const SCStepBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const SCStepBodyContainer = styled.div`
  padding-top: 3rem;
  padding-bottom: 10rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
`;

export const StepBody = ({ children }: StepBodyProps) => {
  return (
    <SCStepBodyContainer>
      <SCStepBody>{children}</SCStepBody>
    </SCStepBodyContainer>
  );
};
